export default __webpack_public_path__ + "static/media/blog-driveway-size-001.14cc00a7.jpg";